








import Vue from 'vue'
import { ReportMenuTreeItem } from '@/model/reporting/ReportMenuTreeItem'
import { LOAD_REPORTS_LIST } from '@/store/action-types'
import { ReportFilterItem } from '@/types/service-response'

interface ComponentData {
  treeItemList: Array<ReportMenuTreeItem>
  selection: number[]
}

interface Child {
  reportId: number
  id: number
  reportName: string
  reportLayout: string
  name: string
  filters: Array<ReportFilterItem>
}

export default Vue.extend({
  name: 'AddressReportingTree',

  props: {
    addressId:{
      type: Number,
      default: undefined
    }
  },

  data (): ComponentData {
    return {
      treeItemList: [],
      selection: []
    }
  },

  watch: {
    selection (newVal: any[]): void {
      if(newVal) {
        this.changeSelection()
      }
    },

    addressId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchData()
      }
    }
  },

  methods: {
    isSelected (item: Child) : boolean {
      const foundSelected: number | undefined = this.selection.find((i: number) => i === item.id)
      return foundSelected ? !!foundSelected : false
    },

    changeSelection (): void {
      if (this.selection.length && this.treeItemList) {
        let payload: { reportItem: Array<ReportFilterItem>, reportLayout: string, reportName: string }[] = []

        this.selection.forEach((selectedId: number) => {
          let childrenList: Child[] = []
          this.treeItemList.forEach((item: ReportMenuTreeItem) => {
            const children: Child | undefined = item.children.find((i: Child) => {
              return i.id === selectedId
            })

            if(children) {
              childrenList.push(children)
            }
          })

          if (childrenList.length > 0) {
            childrenList.forEach((item: Child) => {
              const reportItemList: ReportFilterItem[] = item.filters.map((i: ReportFilterItem) => {
                return i
              })
              payload.push(
                {
                  reportItem: reportItemList,
                  reportLayout: item.reportLayout,
                  reportName: item.reportName
                }
              )
            })
          }
        })

        this.$emit('selectedReport', payload)
      } else {
        this.$emit('selectedReport', [])
      }
    },

    async fetchData (): Promise<void> {
      this.$store.dispatch(LOAD_REPORTS_LIST, this.addressId ? 28 : 25).then((data: ReportMenuTreeItem[]) => {
        let index: number = 0
        this.treeItemList = data.map ((item: ReportMenuTreeItem) => {
          index++
          return {
            children: item.children,
            groupId: item.groupId,
            id: index,
            name: item.name,
            reportGroupName: item.reportGroupName,
          }
        })
      })
    }
  },

  mounted () {
    this.fetchData()
  }

})
